export const Colors = {
    Light: "#A9F0FF",
    Dark: "#26435F"
}